export { accessoryAwsUrl as initAccessoryAWSUrl } from "modules/environments"

export const licenseTypeTable = {
  1: "普通重型",
  2: "普通輕型",
}

export const nonUid = "00000000-0000-0000-0000-000000000000"

export const OCRSysID = "TT000000101"

export const FEDERATION_GLB = "GLB"
export const FEDERATION_GN = "GN"

// Employee promotion code list for accessories shopping mall
export const employeePromotionCodeList = ["GN_Emp80", "GLOBEEMP15AX"]
